/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hold_DurationInputs */

const en_hold_duration = /** @type {(inputs: Hold_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hold Duration`)
};

const es_hold_duration = /** @type {(inputs: Hold_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duracion del apartado`)
};

/**
* | output |
* | --- |
* | "Hold Duration" |
*
* @param {Hold_DurationInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const hold_duration = /** @type {((inputs?: Hold_DurationInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hold_DurationInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hold_duration(inputs)
	return es_hold_duration(inputs)
});